import"react/jsx-runtime";import"@jobseeker/lotus/lib/assets/images";import"@jobseeker/lotus/lib/elements/ButtonV2";import"@mui/material";import"next/image";process.env.NEXT_PUBLIC_APP_NAME;
//# sourceMappingURL=index.js.map
